# This gets automatically populated bij gulp

exports.date = 1490887361
exports.branch = "master"
exports.hash = "17d75f7"
exports.build = 2700
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee